import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { FaCheck } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { RiProgress5Line } from "react-icons/ri";

const ActiveModelsTable = ({ data }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (row) => {
    setExpandedRow(expandedRow === row ? null : row);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.CUSTOM_NAME,
      sortable: true,
      grow: 1.5,
      cell: (row) => (
        <div
          title={row.CUSTOM_NAME}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "110px",
          }}
        >
          {row.CUSTOM_NAME}
        </div>
      ),
    },
    {
      name: "Assembly",
      selector: (row) => row.DRIVER,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div
          title={row.DRIVER}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "110px",
          }}
        >
          {row.DRIVER}
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.STATUS,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div
          title={row.STATUS}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "110px",
          }}
        >
          {row.STATUS}
        </div>
      ),
    },
    {
      name: "DGS Tags",
      selector: (row) =>
        row.DEP_TAG_ALIAS.replace(/[\[\]']/g, "")
          .split(", ")
          .map((tag) => `${tag}`)
          .join(", "),
      sortable: true,
      grow: 1,
      cell: (row) => {
        const tags = row.DEP_TAG_ALIAS.replace(/[\[\]']/g, "")
          .split(", ")
          .map((tag) => `${tag}`)
          .join(", ");
        return (
          <div
            title={tags}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "210px",
            }}
          >
            {tags}
          </div>
        );
      },
    },
    {
      name: "Created Date",
      selector: (row) => row.CREATED_AT,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <div
          title={row.CREATED_AT}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "120px",
          }}
        >
          {row.CREATED_AT}
        </div>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.TRAINING_ST_DATE,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div
          title={row.TRAINING_ST_DATE}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "110px",
          }}
        >
          {row.TRAINING_ST_DATE}
        </div>
      ),
    },
    {
      name: "End Date",
      selector: (row) => row.TRAINING_END_DATE,
      sortable: true,
      cell: (row) => (
        <div
          title={row.TRAINING_END_DATE}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "110px",
          }}
        >
          {row.TRAINING_END_DATE}
        </div>
      ),
    },
    {
      name: "Training Status",
      cell: (row) =>
        row.TRAINING_STATUS === "SUCCEEDED" ? (
          <div
            className="text-green-500 font-medium flex items-center gap-1"
            title="Completed"
          >
            <FaCheck />
            Completed
          </div>
        ) : row.TRAINING_STATUS === "RUNNING" ? (
          <div
            className="text-yellow-600 font-medium flex items-center gap-1"
            title="In Progress"
          >
            <RiProgress5Line />
            In Progress
          </div>
        ) : (
          <div
            className="text-red-600 flex font-medium items-center gap-1.5"
            title="Failed"
          >
            <ImCancelCircle /> Failed
          </div>
        ),
      sortable: true,
      width: "135px",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "13px",
        backgroundColor: "#e3e1e1",
      },
    },
    cells: {
      style: {
        fontSize: "13.4px",
      },
    },
    table: {
      style: {
        border: "1px solid #e3e1e1",
        margin: "0 auto",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row === expandedRow,
      style: {
        borderBottom: "none",
        backgroundColor: "#ededed",
      },
    },
  ];

  return (
    <>
      <div className="w-[65%] ">
        <p className="font-semibold text-2xl text-btn-primary w-[65%] mb-5">
          Existing Models
        </p>
        {data.CUSTOM_NAME && data.CUSTOM_DESC ? (
          <p className="font-semibold text-lg text-btn-primary w-[65%] mb-5">
            {data.CUSTOM_NAME} - {data.CUSTOM_DESC}{" "}
          </p>
        ) : (
          ""
        )}
        <DataTable
          columns={columns}
          data={data}
          responsive
          customStyles={customStyles}
          expandableRows
          expandOnRowClicked
          expandableRowsHideExpander
          expandableRowExpanded={(row) => row === expandedRow}
          onRowClicked={handleRowClick}
          expandableRowsComponent={ExpandedComponent}
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </>
  );
};

export default ActiveModelsTable;

const ExpandedComponent = ({ data }) => (
  <div
    style={{
      padding: "10px 20px",
      fontSize: "13px",
      backgroundColor: "#f9f9f9",
      display: "flex",
      gap: "50px",
    }}
  >
    <div>
      <p className="mb-1">
        <strong>Custom Name : </strong> {data.CUSTOM_NAME ?? "-"}
      </p>
      <p className="mb-1">
        <strong>Custom Description :</strong> {data.CUSTOM_DESC ?? "-"}
      </p>
      <p className="mb-1 ">
        <strong>DGS Tags :</strong>{" "}
        {data.DEP_TAG_ALIAS.replace(/[\[\]']/g, "")
          .split(", ")
          .map((tag) => `${tag}`)
          .join(", ")}
      </p>
      <p className="mb-1">
        <strong>Tag Description : </strong>{" "}
        {data.TAG_NAME
          ? data.TAG_NAME.replace(/\s*\([^)]*\)/g, "")
              .replace(/[\[\]']/g, " ")
              .trim()
          : "-"}
      </p>
      <p className="mb-1">
        <strong>Model Name :</strong> {data.MODEL_ID}
      </p>
      <p className="mb-1">
        <strong>Datasource Id :</strong> {data.DATASOURCE}
      </p>
      <p className="mb-1">
        <strong>Project Name :</strong> {data.PROJECTNAME}
      </p>
      <p className="mb-1">
        <strong>Driver : </strong>
        {data.DRIVER}
      </p>
      <p className="mb-1">
        <strong>Frequency : </strong>
        {data.DATA_FREQ ?? "-"} {data.DATA_FREQ && "mins"}
      </p>
      <p className="mb-1">
        <strong>Business Rule :</strong>{" "}
        {data.BUSINESS_RULES ? (
          <table className="mt-2 bg-white border border-gray-300 rounded">
            <thead>
              <tr className="bg-gray-100 font-normal">
                <th className="px-3 py-2 border-b text-left">Alias</th>
                <th className="px-3 py-2 border-b text-left">Operator</th>
                <th className="px-3 py-2 border-b text-left">Value</th>
              </tr>
            </thead>
            <tbody>
              {JSON.parse(data.BUSINESS_RULES.replace(/'/g, '"')).map(
                (rule, idx) => (
                  <tr key={idx} className="border-b">
                    <td className="px-3 py-2">{rule.ALIAS}</td>
                    <td className="px-3 py-2">{rule.OPERATOR}</td>
                    <td className="px-3 py-2">{rule.VALUE}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        ) : (
          "-"
        )}
      </p>
    </div>

    <div>
      {data.PROJECT_INFO.length != 0 && (
        <p className="mb-1 text-lg">Project Info</p>
      )}
      <ul>
        {data.PROJECT_INFO.map((info, index) => (
          <li key={index}>
            <p className="mb-1 ">
              {" "}
              <strong>Make Manufacturer:</strong> {info.MAKE_MANUFACTURER}
              <br />
            </p>
            <p className="mb-1">
              {" "}
              <strong>Seal Type:</strong> {info.SEAL_TYPE}
              <br />
            </p>
            <p className="mb-1">
              {" "}
              <strong>Design Pressure (Bar):</strong>{" "}
              {info.DESIGN_PRESSURE_BAR || "N/A"}
              <br />
            </p>
            <p className="mb-1">
              {" "}
              <strong>Direction of Rotation:</strong>{" "}
              {info.DIRECTION_OF_ROTATION}
              <br />
            </p>
            <p className="mb-1">
              {" "}
              <strong>Trip Speed (RPM):</strong> {info.TRIP_SPEED_RPM || "N/A"}
              <br />
            </p>
            <p className="mb-1">
              {" "}
              <strong>Maximum Operating Speed (RPM):</strong>{" "}
              {info.MAXIMUM_OPERATING_SPEED_RPM}
            </p>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
